"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ethers = __importStar(require("ethers"));
const wallet_1 = require("../wallet");
const ARHead_json_1 = __importDefault(require("./config/dev/ARHead.json"));
const ARHead_json_2 = __importDefault(require("./config/stg/ARHead.json"));
const ARHead_json_3 = __importDefault(require("./config/prod/ARHead.json"));
const ARHeadMinter_json_1 = __importDefault(require("./config/dev/ARHeadMinter.json"));
const ARHeadMinter_json_2 = __importDefault(require("./config/stg/ARHeadMinter.json"));
const ARHeadMinter_json_3 = __importDefault(require("./config/prod/ARHeadMinter.json"));
let stage = process.env.VUE_APP_STAGE;
let AbiArhead;
let AbiArheadMinter;
switch (stage) {
    case 'dev':
        AbiArhead = ARHead_json_1.default;
        AbiArheadMinter = ARHeadMinter_json_1.default;
        break;
    case 'stg':
        AbiArhead = ARHead_json_2.default;
        AbiArheadMinter = ARHeadMinter_json_2.default;
        break;
    case 'prod':
        AbiArhead = ARHead_json_3.default;
        AbiArheadMinter = ARHeadMinter_json_3.default;
        break;
}
class Metamask {
    constructor() {
        this.iconUrl = '';
        this.walletOptions = {
            signInRequired: false,
            type: wallet_1.WalletType.Injected,
            changableNetwork: false,
        };
        this.isExternalProviderAvailable = () => {
            return global.ethereum !== undefined;
        };
        this.initialize = (walletEventsHandler) => __awaiter(this, void 0, void 0, function* () {
            this.walletEventsHandler = walletEventsHandler;
            global.ethereum.on('accountsChanged', this.onAccountsChanged);
            global.ethereum.on('chainChanged', this.onChainChanged);
            this.provider = this.createProvider();
            const accounts = yield this.provider.send("eth_requestAccounts", []);
            if (!accounts.length) {
                throw Error('No accounts');
            }
            this.walletAddress = yield this.provider.getSigner().getAddress();
            yield this.updateNetworkName();
        });
        this.finalizer = () => __awaiter(this, void 0, void 0, function* () {
            global.ethereum.removeListener('accountsChanged', this.onAccountsChanged);
            global.ethereum.removeListener('chainChanged', this.onChainChanged);
        });
        this.connectToContract = (contractData) => __awaiter(this, void 0, void 0, function* () {
            const signer = this.provider.getSigner();
            this.contract = new ethers.Contract(contractData.token, AbiArhead.abi, signer);
            this.contractMinter = new ethers.Contract(contractData.minter, AbiArheadMinter.abi, signer);
        });
        this.createProvider = () => {
            return new ethers.providers.Web3Provider(global.ethereum);
        };
        this.updateNetworkName = () => __awaiter(this, void 0, void 0, function* () {
            const network = yield this.provider.getNetwork();
            this.networkName = network.name;
        });
        this.onAccountsChanged = () => __awaiter(this, void 0, void 0, function* () {
            yield this.walletEventsHandler();
        });
        this.onChainChanged = () => __awaiter(this, void 0, void 0, function* () {
            this.provider = this.createProvider();
            yield this.updateNetworkName();
            yield this.walletEventsHandler();
        });
        this.mintToken = (tokenId) => __awaiter(this, void 0, void 0, function* () {
            const nftTxn = yield this.contract.safeMint(this.walletAddress, tokenId);
            return nftTxn.wait();
        });
        this.trustedMint = (tokenId, salt, signature) => __awaiter(this, void 0, void 0, function* () {
            const nftTxn = yield this.contractMinter.mintAssignedToken(ethers.BigNumber.from(tokenId), ethers.BigNumber.from(salt), signature);
            return nftTxn.wait();
        });
        this.burnToken = (tokenId) => __awaiter(this, void 0, void 0, function* () {
            const nftTxn = yield this.contract.burn(tokenId);
            return nftTxn.wait();
        });
        this.isTokenExists = (tokenId) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.contract.tokenURI(tokenId);
                return true;
            }
            catch (e) {
                return false;
            }
        });
        this.isTokenOwner = (tokenId) => __awaiter(this, void 0, void 0, function* () {
            const owner = yield this.contract.ownerOf(tokenId).catch(() => null);
            return owner === this.walletAddress;
        });
        this.getAccountAddress = () => __awaiter(this, void 0, void 0, function* () {
            return this.walletAddress;
        });
    }
    getWalletName() {
        return "Metamask";
    }
}
exports.default = Metamask;
